import gql from 'graphql-tag';

export const ADD_CONSENT = gql`
    mutation addConsent($input: ConsentAgreementInput!) {
        addConsent(input: $input)
    }
`;
